import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDisqusComponent } from './simple-icons-disqus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDisqusComponent ],
    exports:      [ SimpleIconsDisqusComponent ],
    bootstrap:    []
})
export class SimpleIconsDisqusModule {}
